import { redirect, RouteObject } from 'react-router-dom'

export const redirectRoutes: RouteObject[] = [
  {
    // Route added for backwards compatibility with the CRM.
    path: '/permits/:sid?',
    loader: ({ params }) => {
      if (params.sid) {
        return redirect(`/locations/${params.sid}/location-management/permits`)
      } else {
        return redirect('/locations/location-management')
      }
    }
  },
  {
    // Route added for backwards compatibility with the CRM.
    path: '/address-scheduler/*',
    loader: ({ params }) => {
      const restOfPath = params['*'] ?? ''

      // Regex that splits the path into two halves: a first segment and the rest of the path.
      const restOfPathRegex = /^(?<firstSegment>[^/?#]*)(?<rest>.*)?$/

      const restOfPathMatch = restOfPath.match(restOfPathRegex)!
      const { firstSegment, rest = '' } = restOfPathMatch.groups as { firstSegment: string; rest: string }

      if (firstSegment === '') {
        // An empty first segment means no locationId was provided, so navigate to the address scheduler overview.
        return redirect('/locations/address-scheduler')
      } else {
        // Otherwise, redirect to the address scheduler with the locationId and the rest of the path.
        return redirect(`/locations/${firstSegment}/address-scheduler${rest}`)
      }
    }
  }
]
